import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
// import { CustomReuseStrategy } from './custom-reuse-strategy';
// import { RouteReuseStrategy } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FlexLayoutModule } from '@angular/flex-layout';

import { AppComponent } from './app.component';
import { ProductsComponent } from './products/products.component';
import { ProductsService } from './products/products.service';
import { FavoritesService } from './products/favorites.service';
import { HttpClientModule } from '@angular/common/http';
import { HomePageComponent } from './home-page/home-page.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxElasticlunrModule } from 'ngx-elasticlunr';

import { SwiperModule } from 'ngx-swiper-wrapper';
import { SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { ControlsService } from './controls.service';
import { SearchService } from './search.service';
import { ConfigurationService } from './configuration.service';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto'
};

import { AppRoutingModule } from './app-routing.module';
import { ProductListingComponent } from './products/product-listing/product-listing.component';
import { ProductCarouselComponent } from './product-carousel/product-carousel.component';
import 'hammerjs';
import { ToolBarComponent } from './tool-bar/tool-bar.component';
import { MaterialModule } from './material/material.module';

import { ProductsCategoriesComponent } from './home-page/products-categories/products-categories.component';
import { SlideComponent } from './product-carousel/slide/slide.component'
import { CategoriesResolverService } from './categories-resolver.service';
import { FileDownloadService } from './products/file-download.service';
// import { WINDOW_PROVIDERS , windowProvider} from './window-providers.service';
// import { WindowService } from './window.service';
import { WindowRefService } from './window-ref.service';
import { BreadcrumbsComponent } from './home-page/breadcrumbs/breadcrumbs.component';
import { SearchResultsComponent } from './search-results/search-results.component';
import { LicenseModalComponent } from './home-page/license-modal/license-modal.component';
import { OrderByLengthPipe } from './order-by-length.pipe';
import { OrderByGroupPipe } from './order-by-group.pipe';
import { LoginReminderModalComponent } from './login-reminder-modal/login-reminder-modal.component';
import { CategoriesComponent } from './categories/categories.component';
import { CategoryComponent } from './home-page/category/category.component';
import { HDRThumbnailComponent } from './hdrthumbnail/hdrthumbnail.component';

export class AppWindow extends Window {};

@NgModule({
  declarations: [
    AppComponent,
    ProductsComponent,
    HomePageComponent,
    ProductListingComponent,
    ProductCarouselComponent,
    ToolBarComponent,
    ProductsCategoriesComponent,
    SlideComponent,
    BreadcrumbsComponent,
    SearchResultsComponent,
    LicenseModalComponent,
    OrderByLengthPipe,
    OrderByGroupPipe,
    LoginReminderModalComponent,
    CategoriesComponent,
    CategoryComponent,
    HDRThumbnailComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    SwiperModule,
    NgxElasticlunrModule.forRoot()
  ],
  providers: [
    ProductsService,
    FavoritesService,
    ConfigurationService,
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    },
    WindowRefService,
    // WindowService,
    // WINDOW_PROVIDERS,
    // windowProvider,
  FileDownloadService,
  ControlsService,
  SearchService
  ],
  entryComponents: [
    LicenseModalComponent,
    LoginReminderModalComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts



// WEBPACK FOOTER //
// ./src/app/app.module.ts